import type { PurchasedGallery } from '../../domain/entities/PurchasedGallery';
import type { PurchasedGalleryRepository } from '../../domain/repositories/PurchasedGalleryRepository';

export class GetPurchasedGalleryUseCase {
  constructor(private readonly repository: PurchasedGalleryRepository) {}

  async execute(code: string, slug: string): Promise<PurchasedGallery> {
    return this.repository.getByAddress(code, slug);
  }
}
